import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { WarningModal } from "../../../components/WarningModal";
import { kanbanSliceSelectors } from "../../../redux/kanban/kanban.selector";
import { kanbanActions } from "../../../redux/kanban/kanban.slice";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { TestIDs } from "../../../tests/types/testIds";
import { AtiraToast } from "../../../utils/AtiraToast";
import { useDrawersContext } from "../../tasks/drawers-context";

export const KanbanCardDeleteModal: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const {
    kanbanCard,
    setKanbanCard,
    kanbanCardDeleteVisible,
    setKanbanCardDeleteVisible,
  } = useDrawersContext();

  const kanban = useAppSelector(kanbanSliceSelectors.selectUserCurrentKanban);
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const localOnClose = () => {
    setKanbanCardDeleteVisible(false);
    setKanbanCard(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);

      await dispatch(
        kanbanActions.deleteKanbanCard({ userId, cardId: kanbanCard?._id! }),
      ).unwrap();

      await dispatch(
        kanbanActions.getUserKanban({ userId, kanbanId: kanban?._id }),
      ).unwrap();

      AtiraToast.success(t("kanban.card.delete.success"));
      localOnClose();
    } catch (e: any) {
      AtiraToast.apiError(e);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (!kanbanCard) {
    return null;
  }

  return (
    <WarningModal
      isOpen={kanbanCardDeleteVisible}
      onClose={localOnClose}
      title={t("kanban.card.delete.modal.title", { name: kanbanCard.title })}
      description={t("kanban.card.delete.modal.description")}
      onConfirm={onDelete}
      confirmButtonText={t("common.delete")}
      loading={loading}
      confirmButtonDataTestId={TestIDs.kanbans.card.delete.modalConfirm}
    />
  );
};
